import React, { Fragment } from 'react';

import { bool } from 'prop-types';

import { Container } from './styles';

const LoadingCircle = ({ isLoading }) =>
  isLoading ? (
    <Container>
      <img src="/images/loader.gif" title="Carregando" alt="Carregando" aria-label="Carregando" />
    </Container>
  ) : (
    <Fragment />
  );

LoadingCircle.propTypes = {
  isLoading: bool,
};

LoadingCircle.defaultProps = {
  isLoading: false,
};

export default LoadingCircle;
